import MegaphoneIcon from './component.jsx'
export default MegaphoneIcon
